import React, { Component } from 'react';
import TransitionGroup from 'react/lib/ReactCSSTransitionGroup';
import rx from 'rx';
import _ from 'lodash';
import { Entry } from 'components/entry/Entry';
import { injectIntl } from 'react-intl';
import { ResultsHeader } from 'components/resultsHeader/ResultsHeader';
import { utils } from 'bastetjs';
import * as animations from 'streams/animations';
import { StickyContainer, Sticky } from 'react-sticky';
import { Configure } from 'anuket';
import { ReportHeader } from '../report/ReportHeader';
import { ReportRow } from '../report/ReportRow';

const styles = {
  container: {
    width: '100%',
    overflow: 'hidden',
    paddingBottom: 97,
    position: 'relative',
    zIndex: 99
  },
  header: {
    background: '#011328'
  }
};

export class RaceResultsComponent extends Component {

  componentDidMount() {
    /**
     * Header column widths need to be set when results come in.
     * @see streams/calculateCellWidths
     */
    window.dispatchEvent(new Event('resize'));
  }

  componentDidUpdate() {
    window.dispatchEvent(new Event('resize'));
  }

  /**
   * Row height is changing on certain breakpoints.
   * @param  {number} windowWidth
   * @return {number} Row height
   */
  _getRowHeight(windowWidth) {
    if(windowWidth <= 580) {
      return 90;
    }
    if(windowWidth <= 880) {
      return 33;
    }
    if(windowWidth <= 1090) {
      return 40;
    }
    if(windowWidth <= 1350) {
      return 50;
    }
    return 45;
  }

  render() {
    const {
      race,
      settings,
      animationType,
      position,
      entries,
      headerColor,
      backgroundColor,
      haveResults,
      panelSettings,
      isRaceResults,
      isReportResults,
      columns = {},
      columnsRatio = {},
    } = this.props;

    Configure.setConfigs({entries});
    const entriesCnt = entries.length;
    const start = position;
    const resultsPerPage = settings.results_per_page < entriesCnt ?
      settings.results_per_page : (animationType === 'scroll' ? entriesCnt - 1 : 10);
    const offset = !haveResults ? 0 : parseInt(resultsPerPage);
    const end = start + offset;
    const numberOfResults = settings.number_of_results < entriesCnt ? settings.number_of_results : entriesCnt;
    const secondEnd = animationType === 'scroll' && end > numberOfResults ? end - numberOfResults : 0;
    const transitionProps = {
      component: 'div',
      className: 'entriesWrapper',
      transitionName: animationType,
      transitionEnterTimeout: animationType === 'scroll' ? 1 : 0,
      transitionLeaveTimeout: 0
    };

    if (entriesCnt > 0) {
      entries[entriesCnt - 1].isLast = secondEnd > 0;
    }

    const height = (_.min([offset, entries.length]) * 2 * this._getRowHeight(window.innerWidth)) + 100 + 'px';
    const containerStyle = _.assign({}, styles.container, { height } );
    styles.header.background = backgroundColor ? backgroundColor : styles.header.background;
    return (
      <StickyContainer id={!haveResults ? 'race-0' : `race-${race.id}`} style={{ height }} style={containerStyle}>
        <Sticky>
          <h3 style={styles.header}>{settings.title}</h3>
          {isRaceResults && <ResultsHeader headerColor={headerColor} haveResults={haveResults} settings={settings} panelSettings={panelSettings}/>}
          {isReportResults && <ReportHeader columns={columns} columnsRatio={columnsRatio} panelSettings={panelSettings}/> }
        </Sticky>
        { haveResults ?
        <TransitionGroup {...transitionProps}>
          {
            _.flatten([entries.slice(start, end), entries.slice(0, secondEnd)]).map((entryResult, ix) => {
              const key = `entry-row-${race.id}-${ix}`;
              if(isReportResults) return <ReportRow key={key} data={entryResult} columnsRatio={columnsRatio}/>;
              else return <Entry key={key} data={entryResult}  settings={settings} panelSettings={panelSettings} />;
            })
          }
        </TransitionGroup> : null }
      </StickyContainer>
    );
  }
}

export const scroll = utils.connectStream({position: animations.scroll})(RaceResultsComponent);
export const slide = utils.connectStream({position: animations.slide})(RaceResultsComponent);



// WEBPACK FOOTER //
// ./components/raceResults/RaceResults.js